import { render } from "./CandidateListItem.vue?vue&type=template&id=c5c9e6e4&scoped=true"
import script from "./CandidateListItem.vue?vue&type=script&lang=js"
export * from "./CandidateListItem.vue?vue&type=script&lang=js"

import "./CandidateListItem.vue?vue&type=style&index=0&id=c5c9e6e4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5c9e6e4"]])

export default __exports__